import { ChevronRight } from 'lucide-react';
import { cn } from '@eombor/ui';
import type { FlowCrumb } from '@eombor/contracts';
import { t } from '../../../shared/i18n/index.js';
import type { FlowNode } from '../api/flow.api.js';

/**
 * TUZILMA BO'YLAB YO'L — bosqichli filtrning o'zi.
 *
 * Yoyiladigan daraxt ataylab ishlatilmadi: ichma-ich yoyilgan satrlarda
 * bir darajadagi narsalar aralashib ketadi va solishtirish buziladi —
 * holbuki rahbarning asosiy ishi aynan solishtirish. Shuning uchun
 * jadval har doim BITTA darajani ko'rsatadi, yo'l esa shu yerda.
 *
 * Oxirgi bo'g'in — HOZIRGI daraja va u bosilmaydi: o'zini qayta
 * so'raydigan tugma «nega hech narsa bo'lmadi?» degan savol tug'dirardi.
 */
export interface FlowCrumbsProps {
  crumbs: readonly FlowCrumb[];
  onGo: (node: FlowNode) => void;
}

export const FlowCrumbs = ({ crumbs, onGo }: FlowCrumbsProps) => (
  <nav aria-label={t('stats.crumbs')} className="min-w-0">
    <ol className="flex min-w-0 flex-wrap items-center gap-x-1 gap-y-1 text-sm">
      {crumbs.map((crumb, index) => {
        const last = index === crumbs.length - 1;
        return (
          <li key={`${crumb.level}:${crumb.parentId ?? ''}`} className="flex min-w-0 items-center">
            {index === 0 ? null : (
              <ChevronRight size={14} aria-hidden className="mx-0.5 shrink-0 text-text-faint" />
            )}
            {last ? (
              /* `aria-current` — ekran o'quvchi yo'lning qayerida
                 turganini aytadi, matnning o'zi esa ko'z uchun. */
              <span aria-current="page" className="truncate font-medium text-text">
                {crumb.name}
              </span>
            ) : (
              <button
                type="button"
                onClick={() => onGo({ level: crumb.level, parentId: crumb.parentId })}
                className={cn(
                  'truncate rounded-[var(--radius-sm)] px-1 py-0.5 text-text-muted',
                  'transition-colors duration-[var(--motion-fast)]',
                  'hover:bg-surface-2 hover:text-text',
                  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
                )}
              >
                {crumb.name}
              </button>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
